// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_Qjn","cls2":"RelatedWorksCard-cls2_qNJ RelatedWorksCard-cls1_Qjn"};